import {createAction, props} from '@ngrx/store';

import {QueueMetricObj} from './metrics.model';

export const updateMetrics = createAction(
    '[Queue Metrics] Update All',
    props<{ metrics: QueueMetricObj[] }>()
);